<script>
import { mapState } from 'vuex';
import { resyncAmplitudeEngagementUser } from '@/plugins/amplitude.js';

export default {
    name: 'AmplitudeHandler',
    computed: {
        ...mapState('Auth', ['user']),
    },
    watch: {
        user: {
            async handler(newUser) {
                if (newUser && this.$amplitude) {
                    const userId = newUser.id.toString();

                    this.$amplitude.setDeviceId(userId);
                    this.$amplitude.setUserId(userId);

                    if (this.$syncAmplitudeUserProfile) {
                        await this.$syncAmplitudeUserProfile(newUser);
                    }

                    try {
                        await resyncAmplitudeEngagementUser(newUser);
                    } catch (error) {
                        console.error('[Amplitude] Failed to resync engagement user:', error);
                    }
                }
            },
            immediate: true,
        },
    },
    render() {
        return null;
    },
};
</script>
